// The ledger register colors + signs each amount by its cash direction so money
// in and money out are distinguishable at a glance. The row's Type column names
// the kind; this is the visual reinforcement. Pure, no React — lives in
// src/lib/finance/ next to triageSuggest.ts.

import { assertNever, type TriageItem } from '@signalvote/shared';

/** Which way cash moves for a ledger row. */
export type AmountDirection = 'in' | 'out';

/**
 * Cash direction of a triage item.
 *
 * - Contribution → `'in'`  (money received).
 * - Expenditure  → `'out'` (money spent).
 * - Refund       → `'out'` (a contribution handed back — cash leaves).
 * - BankLine     → the sign of the bank amount is the direction: a credit
 *                  (`amount >= 0`) is `'in'`, a debit (`amount < 0`) is `'out'`.
 *                  Same `isCredit` rule the ledger + `suggestedKind` already use.
 */
export function triageItemDirection(item: TriageItem): AmountDirection {
  switch (item.kind) {
    case 'Contribution':
      return 'in';
    case 'Expenditure':
    case 'Refund':
      return 'out';
    case 'BankLine':
      return item.bt.amount >= 0 ? 'in' : 'out';
    default:
      return assertNever(item);
  }
}
